import React from "react";
import { Link } from "react-scroll";

function Navbar() {
  const links = [
    { id: 1, links: "about" },
    { id: 2, links: "experience" },
    { id: 3, links: "portfolio" }
  ];
  const socails = [
    {
      id: 1,
      child: (
        <>
          <i className="fa-brands fa-2xl  fa-linkedin"></i>
        </>
      ),
      href: "https://www.linkedin.com/in/leander06/",
    },
    {
      id: 2,
      child: (
        <>
          <i className="fa-solid fa-2xl fa-envelope"></i>
        </>
      ),
      href: "mailto:leanderdsilva06@gmail.com",
    },
    {
      id: 3,
      child: (
        <>
          <i className="fa-brands fa-2xl fa-github"></i>
        </>
      ),
      href: "https://github.com/leander006",
    },
    {
      id: 4,
      child: (
        <>
          <i className="fa-brands fa-2xl fa-instagram"></i>
        </>
      ),
      href: "https://www.instagram.com/leander_dsilva06/",
    },
  ];

  return (
    <div className="flex flex-col lg:items-center h-full px-4 lg:px-0 pt-16 lg:pt-24 w-full space-y-24">
      <div className="flex flex-col lg:items-center w-full space-y-2">
        <h1 className=" text-white text-4xl font-Lora">Leander Dsilva</h1>
        <h2 className="text-white text-xl font-Lora">Full stack developer</h2>
        <p className="leading-normal text-[#94a3b8] font-Lora lg:px-1">I build accessible, pixel-perfect digital experiences for the web.</p>
      </div>

      <div className="lg:flex hidden cursor-pointer">
        <ul className="space-y-6">
          {links.map(({ links, id }) => (
            <li
              key={id}
              className="text-[#64748b] mx-4 font-medium capitalize hover:scale-125 duration-100"
            >
              <Link
                to={links}
                smooth
                spy
                duration={100}
                containerId="scroll-container"
                activeClass="text-white scale-150"
              >
                {links}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex lg:justify-center cursor-pointer lg:pt-32">
        {socails.map(({ child, id, href }) => (
          <li
            key={id}
            className="flex mx-2 list-none hover:scale-125 duration-300"
          >
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className="flex items-center text-white"
            >
              {child}
            </a>
          </li>
        ))}
      </div>
    </div>
  );
}

export default Navbar;
